<template>
    <div class="news-card" :class="{'compact': compact, 'detail': detail }">
        <div class="image-wrapper" :style="{ backgroundImage: `url(${ insight.picture })`}">
            <img class="sr-only" :src="insight.picture" :alt="insight.title" v-if="insight.picture">
        </div>
        <div class="content">
            <div class="tag" v-if="insight.tags">
                <span class="badge mb-1" v-for="(tag, index) in insight.tags.slice(0, 3)" :key="index">{{ tag }}</span>
            </div>
            <h3>{{ insight.title | truncate(55) }}</h3>
            <div class="description" v-if="detail">{{ insight.summary | truncate(150) }}</div>
            <div class="author">
                <hr />
                <h6 v-if="insight.author">
                    <strong>{{ insight.author.name }}</strong>{{ authorTitleCompanyName }}
                </h6>
                <time>{{ displayPublishedAt }} - {{ insight.duration }}</time>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'news-card',

    props: {
        insight: {
            type: Object,
            default() {
                return {};
            },
        },
        compact: {
            type: Boolean,
            default: false,
        },
        detail: {
            type: Boolean,
            default: false,
        },
    },

    filters: {
        truncate(text, length, suffix) {
            if (!text) return '';
            if (text.length <= length) return text;
            suffix = suffix || '...';
            text = text.toString();
            return text.substring(0, length) + suffix;
        },
    },

    computed: {
        authorTitleCompanyName() {
            return this.insight.author.companyName && ', ' + this.insight.author.title + ' at ' + this.insight.author.companyName;
        },

        displayPublishedAt() {
            return new Date(this.insight.publishedAt).toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.news-card{
    cursor: pointer;
    background-color: #ffffff;
    height: 100%;

    &:hover {
        h3 {
            color: $primary;
        }
    }

    .image-wrapper {
        position: relative;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        background-color: #f3f3f3;
        width: 100%;
        height: 125px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .content {
        padding: 20px 20px;

        .tag {
            margin-bottom: 10px;
            .badge {
                font-size: 10px;
                background-color: #8e989f;
                color: #fff;
                letter-spacing: .5px;
                text-transform: uppercase;
                margin-right: 7px;
                padding: 7px;
            }
        }

        h3 {
            font-size: 17px;
            font-weight: 700;
            line-height: 27px;
        }

        .author {
            font-size: 14px;
            font-weight: 400;
            line-height: 17px;
            h6 {
                font-size: inherit;
            }
            time {
                color: grey;
            }
        }
    }
}

.news-card.compact .image-wrapper  {
    display: none;
}

.news-card.detail {
    .image-wrapper {
        height: 150px;

        @include media-breakpoint-up(md) {
            height: 320px;
        }
    }

    h3 {
        font-size: 24px;
    }

    .description {
        font-size: 15px;
        line-height: 27px;
        margin-bottom: 20px;
        color: #505B64;
    }

    hr {
        display: none;
    }
}
</style>
